.messageContainer {
  background-color: #ecf5ff;
  border: 1px solid #a1c6ff;
  border-radius: 4px;
  color: var(--color-easil-black);
  display: flex;
  line-height: 1.71;
  margin-bottom: 40px;
  padding: 16px;
  color: var(--color-easil-black);
}

.messageIcon {
  margin-top: 2px;
}

.messageContent {
  flex: 1 1;
  margin-left: 12px;
}

.messageContent a {
  color: var(--color-easil-blue);
  font-weight: bold;
}
